import './index.scss';
import clsx from 'clsx';
import React from 'react';

import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';

import { colors } from './Config';

export const AVATAR_CLASS = 'avatarElement';

const Avatar = (props) => {
  const formatInitials = props.name
    ? props.name
        .split(' ')
        .map((i) => i?.charAt(0))
        .join('')
    : '';

  const bgColor =
    formatInitials && colors[formatInitials.charAt(0)]
      ? colors[formatInitials.charAt(0)]
      : colors.default || '#ccc';

  return (
    <div className={clsx(AVATAR_CLASS, props.className)}>
      <div className="avatarContainer" data-tooltip-id={`avatar_${props.id}_tooltip`}>
        <div
          className={`avatarItem ${props.disableTooltip ? 'disableTooltip' : ''}`}
          style={{
            backgroundColor: bgColor,
            width: props.width,
            height: props.height,
            fontSize: props.fontSize,
          }}
        >
          {!props.disableInitials && <span>{formatInitials}</span>}
          {props.image && (
            <img
              src={props.image}
              alt="User Avatar"
              onError={(i) => (i.target.style.display = 'none')}
            />
          )}
        </div>
      </div>
      {!props.disableTooltip && (
        <Tooltip id={`avatar_${props.id}_tooltip`} place="bottom" effect="solid">
          {props.name}
        </Tooltip>
      )}
    </div>
  );
};

Avatar.defaultProps = {
  id: 'default',
  disableInitials: false,
};

export default Avatar;
